import api from "@/api";

export default {
  namespaced: true,
  state: () => ({
    classSubjects: [],
    isLoading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
      from: 0,
      to: 0,
    },
  }),
  mutations: {
    SET_CLASS_SUBJECTS(state, subjects) {
      state.classSubjects = subjects;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PAGINATION(
      state,
      { currentPage, totalPages, totalItems, perPage, from, to }
    ) {
      state.pagination = {
        currentPage,
        totalPages,
        totalItems,
        perPage,
        from,
        to,
      };
    },
    ADD_CLASS_SUBJECT(state, newSubject) {
      state.classSubjects.unshift(newSubject);
    },
    UPDATE_CLASS_SUBJECT(state, payload) {
      const index = state.classSubjects.findIndex(
        (s) =>
          s.id === payload.subject_id || s.subject_id === payload.subject_id
      );
      if (index !== -1) {
        state.classSubjects[index] = {
          ...state.classSubjects[index],
          ...payload,
        };
      }
    },
    REMOVE_CLASS_SUBJECT(state, subjectId) {
      state.classSubjects = state.classSubjects.filter(
        (s) => s.id !== subjectId
      );
    },
  },
  actions: {
    async fetchClassSubjects(
      { commit },
      { classId, search = "", status = "" }
    ) {
      try {
        commit("SET_LOADING", true);
        const response = await api.get(`/classes/${classId}/subjects`, {
          params: {
            search,
            status,
          },
        });

        commit("SET_CLASS_SUBJECTS", response.data.data);
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async addSubjectToClass(
      { commit },
      { classId, subject_id, status = "active" }
    ) {
      try {
        commit("SET_LOADING", true);
        const response = await api.post(`/classes/${classId}/subjects`, {
          subject_id,
          status,
        });

        commit("ADD_CLASS_SUBJECT", {
          class_id: classId,
          subject_id: subject_id,
          status: status,
          subject: response.data.data.subject,
        });

        return response.data;
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateClassSubject({ commit }, { classId, subjectId, status }) {
      try {
        commit("SET_LOADING", true);
        const response = await api.put(
          `/classes/${classId}/subjects/${subjectId}`,
          {
            status,
          }
        );

        commit("UPDATE_CLASS_SUBJECT", {
          subject_id: subjectId,
          status: status,
          updated_at: new Date().toISOString(),
        });

        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async removeSubjectFromClass({ commit }, { classId, subjectId }) {
      try {
        commit("SET_LOADING", true);
        await api.delete(`/classes/${classId}/subjects/${subjectId}`);
        commit("REMOVE_CLASS_SUBJECT", subjectId);
      } catch (error) {
        commit("SET_ERROR", error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    clearError({ commit }) {
      commit("SET_ERROR", null);
    },
  },
  getters: {
    getClassSubjects: (state) => state.classSubjects,
    getClassSubjectById: (state) => (id) =>
      state.classSubjects.find((s) => s.id === id),
    isLoading: (state) => state.isLoading,
    getError: (state) => state.error,
    getPagination: (state) => state.pagination,
    activeClassSubjects: (state) => {
      return (
        state.classSubjects.filter((s) => s.pivot?.status === "active") || []
      );
    },
    inactiveClassSubjects: (state) =>
      state.classSubjects.filter((s) => s.pivot?.status === "inactive"),
  },
};
